import { Injectable } from '@angular/core';
import { UrlBuilder } from '../../../shared/crud/api/url-builder';
import { CampaignId } from '../../campaign-util/shared/campaign-id';

@Injectable()
export class CampaignUrlBuilder extends UrlBuilder {

  constructor(private campaignId: CampaignId) {
    super();
  }

  getBaseUrl(): string {
    return '/cms/campaign' + (this.campaignId.getId() ? '/' + this.campaignId.getId() : '');
  }
}
